import MarkdownContent from "features/MarkdownContent";
import {
  AskPaperThreadMessage as AskPaperThreadMessageType,
  AskPaperThreadRole,
} from "helpers/api";

type AskPaperThreadMessageProps = {
  message: AskPaperThreadMessageType;
  onSelectExcerpt?: (text: string) => void;
};

function AskPaperThreadMessage({
  message,
  onSelectExcerpt,
}: AskPaperThreadMessageProps) {
  if (message.role === AskPaperThreadRole.USER) {
    return (
      <div className="flex flex-col gap-2 px-5 py-3 ml-auto rounded-br-sm bg-accent-bg-subtle rounded-xl">
        {message.content}
      </div>
    );
  } else if (message.role === AskPaperThreadRole.ASSISTANT) {
    return (
      <div className="flex flex-col gap-2 px-5 py-3 mr-auto rounded-tl-sm bg-bg-faint rounded-xl">
        <MarkdownContent onSelectExcerpt={onSelectExcerpt}>
          {message.content}
        </MarkdownContent>
      </div>
    );
  } else {
    throw new Error(`Invalid ask paper message: ${message.role}`);
  }
}

export default AskPaperThreadMessage;
